<template>
  <vs-row vs-justify="center" id="team-box">
    <vs-col>
      <vs-card>
        <!-- ADD BUTTON -->
        <vs-row>
          <vs-col>
            <vs-card vs-offset="9" vs-w="3">
              <vs-button
                id="add-team-form"
                icon="add"
                color="primary"
                @click="activePrompt = true"
              >{{$t('Team.AddTeamMemberButton')}}</vs-button>
            </vs-card>
          </vs-col>
        </vs-row>
        <!-- END OFF ADD BUTTON -->
        <vs-row>
          <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
            <index :teamMembers="teamMembers"></index>
            <vs-pagination :total="totalPages" @change="handleChangePage" v-model="currentPage"></vs-pagination>
          </vs-col>
        </vs-row>
      </vs-card>
      <!-- ALL PROMPT -->
      <div>
        <!-- Add membre -->
        <vs-prompt
          color="primary"
          @accept="submitForm"
          @close="close"
          @cancel="close"
          :active.sync="activePrompt"
          :title="$t('Team.AddTeamMemberPrompt.Title')"
          :accept-text="$t('Team.AddTeamMemberPrompt.SubmitButton')"
          :cancel-text="$t('Team.AddTeamMemberPrompt.CancelButton')"
        >
        <vs-card>
          <div v-bar class="vs-scrollable">
            <div>
              <div class="con-exemple-prompt px-4 py-3">
                <vs-row>
                  <vs-col vs-w="12">
                    <vs-input
                      :danger="errors.lname"
                      :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.LastName')})"
                      :label="$t('Profile.LastName')"
                      v-model="member.name"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-input
                  :danger="errors.email"
                  :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Email')})"
                  :label="$t('Profile.Email')"
                  v-model="member.email"
                  class="w-100 mb-2"
                />

                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                      :danger="errors.password"
                      :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Password')})"
                      :label="$t('Profile.Password')"
                      v-model="member.password"
                      type="password"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                      :danger="errors.password_confirm"
                      :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.PasswordConfirm')})"
                      :label="$t('Profile.PasswordConfirm')"
                      type="password"
                      v-model="member.password_confirm"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-select
                  class="w-100 mb-2"
                  :danger="errors.role"
                  :danger-text="$t('Errors.Required', {field: $t('Profile.Role')})"
                  :label="$t('Profile.Role')"
                  v-model="member.role"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item,index) in positions"
                  />
                </vs-select>

                <vs-select
                  class="w-100 mb-2"
                  :label="$t('Profile.Department')"
                  v-if="departments.length"
                  v-model="department"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item,index) in departments"
                  />
                </vs-select>
              </div>
            </div>
          </div>
        </vs-card>
      </vs-prompt>
        <!-- END OF Add membre -->
      </div>
      <!-- END OFF ALL PROMPT -->
    </vs-col>
  </vs-row>
</template>

<script>
import index from "../../components/Team/index";
import addMember from "../../components/Team/addMember";
import edit from "../../components/Team/edit";
import { teamService } from '../../_services';

export default {
  name: "Team",
  data: () => ({
    member : {
      name : "",
      email :"",
      password:"",
      password_confirm  : "",
      role : "",
      type :"SUPER"
    },
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    title: "Team",
    activePrompt: false,
    activeUpdatePrompt: false,
    workingDaysActivePrompt: false,
    teamMembers: [],
    positions: [],
    departments: [],
    fname: "",
    lname: "",
    telephone: "",
    email: "",
    password: "",
    password_confirm: "",
    role: "",
    department: "",
    photo: "",
    editPhoto: "",
    selected: {},
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    maxItems: 0,
    errors: {
      fname: false,
      lname: false,
      telephone: false,
      email: false,
      password: false,
      password_confirm: false,
      role: false,
      selected: {
        fname: false,
        lname: false,
        telephone: false,
        email: false,
        password: false,
        password_confirm: false,
        role: false
      }
    },
    steps: [
      {
        target: "#add-team-form", // We're using document.querySelector() under the hood
        params: {
          placement: "right" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        }
      },
      {
        target: "#edit-team-button",
        params: {
          placement: "right" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        }
      }
    ]
  }),
  methods: {
    submitForm() {
      console.log("Form well submited");
      teamService.addTeamMember(this.member).then(function(data){
            console.log(data);

      }).bind(this);
    },
    close() {
      this.member.fname = "";
      this.member.name = "";
      this.member.telephone = "";
      this.member.email = "";
      this.member.password = "";
      this.member.password_confirm = "";
      this.member.role = "";
      this.activePrompt=false;
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
    validateFields() {
      this.errors.fname = !this.fname || this.fname.length < 3 ? true : false;
      this.errors.lname = !this.lname || this.lname.length < 3 ? true : false;
      this.errors.telephone = !(
        this.telephone.length < 3 || !this.isValidPhoneNumber(this.telephone)
      )
        ? false
        : true;
      this.errors.password = this.password ? false : true;
      this.errors.password_confirm = this.password_confirm
        ? this.password == this.password_confirm
          ? false
          : true
        : true;
      this.errors.role = this.role ? false : true;
      if (this.email.length > 0) {
        this.errors.email = this.isValidEmail(this.email) ? false : true;
      } else {
        this.errors.email = false;
      }

      let {
        fname,
        lname,
        telephone,
        email,
        password,
        password_confirm,
        role
      } = this.errors;
      return !(
        fname ||
        lname ||
        telephone ||
        email ||
        password ||
        password_confirm ||
        role
      );
    },
    validateUpdateCustomerFields() {
      this.errors.selected.fname = this.selected.fname
        ? this.selected.fname.length < 3
          ? true
          : false
        : true;
      this.errors.selected.lname = this.selected.lname
        ? this.selected.lname.length < 3
          ? true
          : false
        : true;
      this.errors.selected.telephone = this.selected.telephone
        ? this.isValidPhoneNumber(this.selected.telephone)
          ? false
          : true
        : true;
      this.errors.selected.role = this.selected.role ? false : true;
      if (this.selected.email.length > 0) {
        this.errors.selected.email = this.isValidEmail(this.selected.email)
          ? false
          : true;
      } else {
        this.errors.selected.email = false;
      }

      let { fname, lname, telephone, email, role } = this.errors.selected;
      return !(fname || lname || telephone || email || role);
    },
    reset() {
      this.fname = "";
      this.lname = "";
      this.email = "";
      this.telephone = "";
      this.password = "";
      this.password_confirm = "";
      this.role = "";
      this.photo = "";
    },
    isValidPhoneNumber(value) {
      // let phoneNumber = this.phone_number;
      return /^\d+$/.test(value);
    },
    isValidEmail: function(value) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    },
    showLoading() {
      this.$vs.loading({
        container: "#team-box",
        scale: 0.6
      });
    },
    hideLoading() {
      this.$vs.loading.close("#team-box > .con-vs-loading");
    },
    handleSelected() {
      /* eslint-disable */
      console.log(this.selected);
    },
    handleChangePage(page) {
      this.showLoading();
      teamService.getPage(page).then(function (data) {
          this.teamMembers=data.accounts.data;
         
      }.bind(this)).finally(() => {
        this.hideLoading();
      });
    },
    close() {
      this.fname = "";
      this.lname = "";
      this.telephone = "";
      this.email = "";
      this.password = "";
      this.password_confirm = "";
      this.role = "";
    },
    
    
    submitWorkingDaysUpdate() {
      this.showLoading();
      this.workingDaysActivePrompt = true;

      // teamService.updateWorkingDays(this.selected.id, {working_days: JSON.stringify(this.selected.workingDays)}).then(function () {
      //   this.handleChangePage(this.currentPage);
      //   this.workingDaysActivePrompt = false;
      //   this.notify(this.$t('Toasts.Successful'), this.$t('Team.WorkingDaysPrompt.ToastSuccess'), 'success');
      // }.bind(this)).catch(function () {
      //   this.notify(this.$t('Toasts.Error'), this.$t('Team.WorkingDaysPrompt.ToastFail'), 'danger');
      // }.bind(this)).finally(function () {
      //   this.hideLoading()
      // }.bind(this));
    },
    handleSort(key, active) {
      /* eslint-disable */
      console.log({ key, active });
    },
    formatDate: function(value) {
      let date = this.$moment(value).format("DD MMMM YYYY");
      return date;
    },
    deleteMember(member) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Team.DeleteTeamMemberPrompt.Title"),
        text: this.$t("Team.DeleteTeamMemberPrompt.Text", {
          name: member.fname + " " + member.lname
        }),
        acceptText: this.$t("Toasts.AcceptButton"),
        cancelText: this.$t("Toasts.CancelButton"),
        accept: function() {
          this.showLoading();
          // teamService.delete(member.id).then(function (data) {
          //   this.handleChangePage(this.currentPage);
          //   this.notify(this.$t('Toasts.Successful'), this.$t('Team.DeleteTeamMemberPrompt.ToastSuccess'), 'warning');
          // }.bind(this)).catch(function () {
          //   this.notify(this.$t('Toasts.Error'), this.$t('Team.DeleteTeamMemberPrompt.ToastFail'), 'danger');
          // }.bind(this)).finally(function () {
          //   this.hideLoading();
          // }.bind(this));
        }.bind(this)
      });
    },
    promptShow() {
      this.$tours["TeamA"].stop();
      this.activePrompt = true;
      this.steps[0].content = this.$t("Customer.Prompt.Content");
      this.steps[0].target = "footer .vs-button-filled";
      this.steps[0].params.placement = "auto";
      setTimeout(() => this.$tours["TeamB"].start(), 500);
    },
    promptShowNew() {
      this.$tours["TeamB"].stop();
      this.activePrompt = false;
      setTimeout(() => this.$tours["TeamA"].start(1), 500);
    },
    goToNextPage() {
      router.push({ path: "/settings/services?istour=on" });
    }
  },
  computed: {},
  mounted() {
    this.showLoading();
    teamService.getAll().then(function(data){
    this.teamMembers=data.accounts.data;
    this.totalItems = data.accounts.total;
    this.maxItems = data.accounts.per_page;
    this.totalPages = data.accounts.last_page;
    }.bind(this))
    .finally(() => {
      this.hideLoading();
    });
  },
  components: {
    index,
    addMember,
    edit
  }
};
</script>
